import { rpx } from '@/utils'
import styled, { css } from 'styled-components'

export const ToastWrapper = styled.div.attrs<{
  type?: 'div' | 'dialog'
}>((props) => ({
  type: props.type || 'div',
}))`
  width: fit-content;
  height: fit-content;
  ${(props) => {
    switch (props.type) {
      case 'dialog':
        return css`
          padding: 0;
          background: transparent;
          border: none;
          overflow: visible;

          &:focus-visible {
            outline: none;
          }

          &::backdrop {
            display: none;
          }
        `

      default:
        return css`
          position: absolute;
          z-index: 99;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
          margin: auto;
        `
    }
  }};
`

const gradientPoint = 25
export const ToastBody = styled.div<{ $landscape: boolean }>`
  font-size: ${rpx(28)};
  color: rgba(241, 241, 241, 1);
  text-align: center;
  box-sizing: border-box;
  padding: ${rpx(15)} ${rpx(70)};
  min-width: ${rpx(314)};
  max-width: ${(props) => rpx(!props.$landscape ? 563 : 885)};
  background: linear-gradient(
    90deg,
    rgba(18, 18, 18, 0),
    rgba(18, 18, 18, 0.7) ${gradientPoint}%,
    rgba(18, 18, 18, 1),
    rgba(18, 18, 18, 0.7) ${100 - gradientPoint}%,
    rgba(18, 18, 18, 0)
  );
  border-radius: ${rpx(8)};
`
